module.exports = __webpack_public_path__ + "static/img/pro_tab6.72011dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro_tab6.jpg
// module id = z/5b
// module chunks = 171